<script setup lang="ts">
import { useMetadataStore } from "@/stores/metadata-store";
import { useCaseFileStore } from "@/stores/case-file-store";

import type { Metadata } from "@/models/Metadata";

withDefaults(defineProps<{ file: Metadata }>(), {  })
const emit = defineEmits<(e: "refreshed") => void>();

async function refresh(): Promise<void> {
  await useMetadataStore().refresh();
  useCaseFileStore().setCommittedRedactionsState(__props.file.fileReference, false);
  emit("refreshed");
}
</script>

<template>
  <div>
    <i class="fas fa-eraser tw-mr-5 tw-text-6xl tw-text-red-600" />
    <div v-if="file.edxProcessingStatus === 'issue'" class="tw-flex-1">
      <h3 class="tw-mb-4 tw-text-xl">
        Something went wrong trying to commit redaction to this document, please raise with the support team
      </h3>
    </div>
    <div v-else class="tw-flex-1">
      <h3 class="tw-mb-4 tw-text-xl">
        We are currently committing redactions to this file. It will be available to view once this is complete.
      </h3>
      <p class="tw-text-lg">
        Please click
        <a href="#" class="tw-font-bold" @click.prevent="refresh()"> here </a>
        to refresh the status of the file.
      </p>
    </div>
  </div>
</template>
